// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.liftShiftText {
  font-size: 5rem;
  font-family: Indie Flower !important;
  color: #f0592a;
  text-align: center;
  margin-top: -1.6rem;
}

.liftShiftRowMain {
  display: flex;
  justify-content: center;
}

.liftShiftTextRow {
  display: flex;
  justify-content: center;
  width: 100%;
}

.lsSecHead {
  font-weight: 700;
  margin-left: 4%;
}

.lsContent {
  margin: 4.2vh 0;
  display: flex;
  text-align: center;
  font-weight: 500;
}

.liftShiftImgCol {
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
}
@media (max-width: 575px) {
  .liftShiftImgCol {
    margin: 2rem 0;
  }
}

.liftShiftImgCol p {
  color: #fff;
  font-size: 1.46vw !important;
  text-align: center !important;
}
@media (max-width: 768px) {
  .liftShiftImgCol p {
    font-size: 22.5px !important;
  }
}

.liftShiftImgCol span {
  font-size: 2vw !important;
  text-align: center !important;
  color: #f0592a;
}
@media (max-width: 768px) {
  .liftShiftImgCol span {
    font-size: 31.5px !important;
  }
}

.liftShiftIframe {
  width: 100%;
  height: 70vh;
}
@media (max-width: 768px) {
  .liftShiftIframe {
    display: none;
  }
}

.liftShiftIframeMob {
  display: none;
}
@media (max-width: 768px) {
  .liftShiftIframeMob {
    display: flex;
    width: 100%;
    height: 100vh;
  }
}

@media (min-width: 2100px) {
  .liftShiftText {
    font-size: 6rem;
  }
}
.graph {
  width: 1170px;
}
@media (min-width: 992px) and (max-width: 1024px) {
  .graphImg {
    width: 750px;
  }
}
@media (min-width: 768px) and (max-width: 992px) {
  .graphImg {
    width: 800px;
  }
}
@media (min-width: 280px) and (max-width: 768px) {
  .graphImg {
    width: 646px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/LiftShift/liftShift.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,oCAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AACF;;AACA;EACE,aAAA;EACA,uBAAA;AAEF;;AACA;EACE,aAAA;EACA,uBAAA;EACA,WAAA;AAEF;;AAAA;EACE,gBAAA;EACA,eAAA;AAGF;;AADA;EACE,eAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;AAIF;;AADA;EACE,aAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;AAIF;AAHE;EALF;IAMI,cAAA;EAMF;AACF;;AAHA;EACE,WAAA;EACA,4BAAA;EACA,6BAAA;AAMF;AALE;EAJF;IAKI,4BAAA;EAQF;AACF;;AALA;EACE,yBAAA;EACA,6BAAA;EACA,cAAA;AAQF;AAPE;EAJF;IAKI,4BAAA;EAUF;AACF;;AAPA;EACE,WAAA;EACA,YAAA;AAUF;AATE;EAHF;IAII,aAAA;EAYF;AACF;;AATA;EACE,aAAA;AAYF;AAXE;EAFF;IAGI,aAAA;IACA,WAAA;IACA,aAAA;EAcF;AACF;;AAXA;EACE;IACE,eAAA;EAcF;AACF;AAXA;EACE,aAAA;AAaF;AARE;EADF;IAEI,YAAA;EAWF;AACF;AAVE;EAJF;IAKI,YAAA;EAaF;AACF;AAZE;EAPF;IAQI,YAAA;EAeF;AACF","sourcesContent":[".liftShiftText {\n  font-size: 5rem;\n  font-family: Indie Flower !important;\n  color: #f0592a;\n  text-align: center;\n  margin-top: -1.6rem;\n}\n.liftShiftRowMain {\n  display: flex;\n  justify-content: center;\n}\n\n.liftShiftTextRow {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n}\n.lsSecHead {\n  font-weight: 700;\n  margin-left: 4%;\n}\n.lsContent {\n  margin: 4.2vh 0;\n  display: flex;\n  text-align: center;\n  font-weight: 500;\n}\n\n.liftShiftImgCol {\n  display: flex;\n  text-align: center;\n  justify-content: center;\n  align-items: center;\n  @media (max-width: 575px) {\n    margin: 2rem 0;\n  }\n}\n\n.liftShiftImgCol p {\n  color: #fff;\n  font-size: 1.46vw !important;\n  text-align: center !important;\n  @media (max-width: 768px) {\n    font-size: 22.5px !important;\n  }\n}\n\n.liftShiftImgCol span {\n  font-size: 2vw !important;\n  text-align: center !important;\n  color: #f0592a;\n  @media (max-width: 768px) {\n    font-size: 31.5px !important;\n  }\n}\n\n.liftShiftIframe {\n  width: 100%;\n  height: 70vh;\n  @media (max-width: 768px) {\n    display: none;\n  }\n}\n\n.liftShiftIframeMob {\n  display: none;\n  @media (max-width: 768px) {\n    display: flex;\n    width: 100%;\n    height: 100vh;\n  }\n}\n\n@media (min-width: 2100px) {\n  .liftShiftText {\n    font-size: 6rem;\n  }\n}\n\n.graph {\n  width: 1170px;\n  @media (min-width: 280px) and (max-width: 768px) {\n  }\n}\n.graphImg {\n  @media (min-width: 992px) and (max-width: 1024px) {\n    width: 750px;\n  }\n  @media (min-width: 768px) and (max-width: 992px) {\n    width: 800px;\n  }\n  @media (min-width: 280px) and (max-width: 768px) {\n    width: 646px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
